module.exports = __webpack_public_path__ + "static/media/0258_Small.2fc05df1.jpg";